var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.833,10.71h5.016c.99,3.642,4.745,5.792,8.388,4.802,2.339-.636,4.167-2.463,4.803-4.802h22.127c1.013,0,1.833-.821,1.833-1.833s-.821-1.833-1.833-1.833h-22.127c-.99-3.642-4.745-5.792-8.388-4.802-2.339.636-4.167,2.463-4.803,4.802H3.833c-1.013,0-1.833.821-1.833,1.833s.821,1.833,1.833,1.833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.167,22.167h-5.016c-.988-3.642-4.741-5.793-8.383-4.805-2.341.635-4.17,2.464-4.806,4.805H3.833c-1.013,0-1.833.821-1.833,1.833s.821,1.833,1.833,1.833h22.128c.988,3.642,4.741,5.793,8.383,4.805,2.341-.635,4.17-2.464,4.806-4.805h5.016c1.013,0,1.833-.821,1.833-1.833s-.821-1.833-1.833-1.833Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.167,37.29h-22.127c-.99-3.642-4.745-5.792-8.388-4.802-2.339.636-4.167,2.463-4.803,4.802H3.833c-1.013,0-1.833.821-1.833,1.833s.821,1.833,1.833,1.833h5.016c.99,3.642,4.745,5.792,8.388,4.802,2.339-.636,4.167-2.463,4.803-4.802h22.127c1.013,0,1.833-.821,1.833-1.833,0-1.012-.821-1.833-1.833-1.833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.4660350a624972ad3fff87c759e13591.svg";
export { ForwardRef as ReactComponent };